import { submitFetch } from '@/js/components/common'

import Tab from '@/js/components/tab'
import articleHtml from '@/html/article.html'
import Handlebars from 'handlebars'
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';
import 'swiper/css/effect-fade';

const main = () => {
    if (!document.querySelector('#page-home')) return;

    const tab = new Tab({
        mainSelector: '.tag-area'
    })

    const slider = new Swiper(".slide", {
        modules: [Autoplay, Pagination],
        spaceBetween: 0,
        loop: true,
        speed: 1000,
        slidesPerView: 1,
        centeredSlides: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            waitForTransition: false,
        },
        pagination: {
            el: '.pagination',
        },
        breakpoints: {
            640: {
                slidesPerView: 1.66,
            },
        },
    })

    $('.tag-area .button').on('click', e => {
        $('#main-header .article-search').addClass('open')
    })

    $('.article a.more').on('click', e => {
        const page = $(e.currentTarget).attr('data-page')
        const path = $(e.currentTarget).attr('href')
        const per_page = $(e.currentTarget).attr('data-per-page')

        submitFetch(path, 'GET', { page, per_page })
            .then(resp => {
                $(e.currentTarget).attr('data-page', resp.next_page_url ? Number(resp.current_page) + 1 : '')
                if (!resp.next_page_url) {
                    $('.article a.more').hide()
                }
                resp.data.forEach(data => {
                    const template = Handlebars.compile(articleHtml)
                    const obj = template({
                        link: `/article/${data.id}`,
                        title: data.title,
                        date: data.date,
                        type: data.type_text,
                        category: data.category_text,
                        pic: data.thumbnail_url,
                        editor: {
                            pic: data.editor.picture_small_url,
                            name: data.editor.name,
                            belong: data.editor.belong,
                        }
                    })
                    $('main .article > ul').append($(obj).hide().fadeIn())
                })
            })
        return false
    })

}
export default main;
